import { Skeleton } from '@material-ui/lab';
import cx from 'classnames';
import React, { memo } from 'react';
import { FBMPIProcedureItem, FBMPIProcedureProps, FBProcedureItemLocale, FBProcedureItemOmitAction, FBProcedureItemType, FBProvider } from '..';
import { translate } from '../../../common/intl';
import FBDeferredRender from '../FBDeferredRender/FBDeferredRender';
import Actions from './components/actions';
import FBMPIProcedureDescription from './components/description';
import { withFBMPIProcedure } from './FBMPIProcedure.wrap';
import useStyles from './styles';

const FBMPIProcedure: React.FunctionComponent<FBMPIProcedureProps> = ({
  mpiProcedureState,
  isPreview = false,
  stepIndex = 0,
  disabled = false,
  items = [],
  processedTypes = [],
  name = '_undefined_',
  autoFocus = false,
  autoScrollTo = false,
  handleAdd,
  onKeyDown,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root} data-cy={`mpiprocedure-${stepIndex}`}>
      {!isPreview && <Actions disabled={disabled} handleAdd={handleAdd} />}
      <div
        className={classes.stepTitle}
        data-cy="form.builder.step.number"
      >
        {translate('form.builder.step.number', { number: stepIndex })}
      </div>
      <FBDeferredRender
        order={stepIndex * 10}
        immediate={autoFocus || autoScrollTo}
        placeholder={(
          <Skeleton
            className={classes.skeleton}
            width="100%"
            variant="rect"
            height={64}
          />
        )}
      >
        <FBMPIProcedureDescription
          {...{
            disabled,
            autoFocus,
            autoScrollTo,
            onKeyDown,
            name,
            stepIndex,
            isPreview,
          }}
        />
      </FBDeferredRender>
      <div className={cx({ [classes.paddedItems]: !isPreview })}>
        <FBProvider {...{ mpiProcedureState }}>
          {items.map((item, typeIndex) => (
            <div
              key={`procedure-item-${item.type}`}
              data-cy={`procedure-item-${item.type}`}
              className={cx(
                classes.item,
                `item-type-${item.type}`,
                {
                  [classes.paddedItem]: !isPreview,
                  [classes.itemFirst]: typeIndex > 0,
                  [classes.itemLast]: typeIndex === items.length - 1,
                  [classes.itemAlone]: FBProcedureItemOmitAction.includes(item.type),
                },
              )}
            >
              {!FBProcedureItemOmitAction.includes(item.type) && (
                <div className={classes.itemTitle} data-cy={FBProcedureItemLocale[item.type]}>
                  {translate(FBProcedureItemLocale[item.type])}
                </div>
              )}
              <FBDeferredRender
                order={stepIndex * 10 + typeIndex + 1}
                ready={processedTypes.includes(item.type)}
                placeholder={(
                  <Skeleton
                    className={classes.skeleton}
                    width="100%"
                    variant="rect"
                    height={item.type === FBProcedureItemType.attachments ? 42 : 64}
                  />
                )}
              >
                <FBMPIProcedureItem {...item} />
              </FBDeferredRender>
            </div>
          ))}
        </FBProvider>
      </div>
    </div>
  );
};

export default memo(withFBMPIProcedure(FBMPIProcedure));
